"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactPhoneNumber = void 0;
var ocm_object_1 = require("@ocm/services/ocm-object");
var contactPhoneNumber = function () {
    switch (ocm_object_1.country) {
        case "ch":
            return {
                href: "tel:+41435087740",
                display: "+41 43 5087740",
            };
        case "at":
            return {
                href: "tel:+43720882390",
                display: "+43 720 882390",
            };
        default:
            return {
                href: "tel:+4971231789978",
                display: "+49 7123 1789978",
            };
    }
};
exports.contactPhoneNumber = contactPhoneNumber;
